import React from 'react'
import { CardText } from './Footer.styled'

const FooterText = ({ content, isDepenednt }) => {
  return <CardText isDepenednt={isDepenednt}>{content}</CardText>
}
export default FooterText
